<template>
	<div class="content-page content-page--integration-manager">
		<ActionSetNav
			:display="displayNav"
			:name="currentCustomerName"
			:actions="actions"
		/>
		<div class="content-page__heading">
			<div class="content-page__breadcrumb-title">
				<Breadcrumbs :items="urlNames" />
				<h2 class="content-page__title">
					<!-- {{ pageTitle }} -->
				</h2>
			</div>
			<div class="content-page__actions">
				<Button
					className="btn--has-icon"
					iconClassName="icon-more"
					labelText="Add"
					:btnClick="addSiteBod"
					:iconBeforeLabel="true"
					:disabled="!canCreate"
				/>
			</div>
		</div>
		<div class="results-toolbar results-toolbar--search-simple-filter">
			<div
				class="
				results-toolbar results-toolbar--variant-two"
				ref="customerResultToolbar"
			>
				<div class="results-toolbar__search">
					<Search
						variant="toggle-icons"
						placeholder="Search by bodtype"
						v-model="filters.search"
					/>
				</div>
				<div class="results-toolbar__sort">
					<DropdownSort
						:options="ddsOptions"
						:showClearSelectedButton="false"
						v-model="ddsValue"
					/>
				</div>
			</div>
			<div class="results-toolbar__filter">
				<DropdownV2
					:options="statusTypeOptions"
					v-model="filters.status"
					defaultValue="all"
				/>
			</div>
			<div class="results-toolbar__counter">
				<ResultCounter :counter="resultCounter" v-if="hasResults" />
			</div>
		</div>
		<ScrollContainer
			v-if="hasResults"
			variant="infinity-scroll"
			:hasMoreItems="hasMoreItemsToLoad"
			@scrollEnd="handleScrollEnd"
		>
			<SiteBodList :items="siteBodsList" />
		</ScrollContainer>
		<Spinner v-if="loading" :processor="{ loading: true }" />
		<NoResults v-if="!loading && !hasResults" />

		<SiteBodFlyout
			:display="showModalSiteBod"
			:siteBods="sitebods"
			:siteId="integrationId"
			:source="sitebod"
		/>
	</div>
</template>
<script>
import ActionSetNav from '@/site-components/actions-set/action-set-nav';
import Button from '@/components/forms/button/button';
import Search from '@/components/forms/search/search';
import DropdownV2 from '@/components/forms/dropdown/dropdown-v2.vue';
import SiteBodList from './sitebod-list';
import Breadcrumbs from '@/components/shells/breadcrumbs/breadcrumbs';
import SiteBodFlyout from './sitebod-flyout';
import ScrollContainer from '@/components/shells/scroll-container/scroll-container';
import Spinner from '@/components/visual/spinner/spinner';
import NoResults from '@/site-components/no-results/no-results';
import DropdownSort from '@/components/forms/dropdown/dropdown-sort';
import ResultCounter from '@/site-components/result-counter/result-counter';
import { mapActions, mapGetters } from 'vuex';
//mixins
import ValidatePermissions from '@/sections/integration/validate-permission-mixins';
import CustomerOptionsMixins from '@/mixins/customers/customer-options';
//constants
import {
	MODULE_NAME as moduleName,
	RELOAD_SITEBODS,
	SITEBOD,
	SITEBODS,
	SET_SITEBODS,
	SHOW_MODAL_SITEBOD,
	INTEGRATIONS
} from '@/sections/integration/integrations-mutation-types';
//functions
import { getDifferentValues } from '@/utils/function';
import _ from 'lodash';

//import { GET_CUSTOMER_OPTION_NAME } from '@/sections/options/options-mutation-type';

export default {
	name: 'IntegrationSiteBod',
	mixins: [ValidatePermissions, CustomerOptionsMixins],
	components: {
		ActionSetNav,
		Breadcrumbs,
		Search,
		DropdownV2,
		Button,
		SiteBodList,
		SiteBodFlyout,
		ScrollContainer,
		Spinner,
		NoResults,
		DropdownSort,
		ResultCounter
	},
	props: {
		thirdPartyId: {
			type: Number
		},
		status: {
			type: String
		},
		search: {
			type: String,
			default: ''
		},
		count: {
			type: Number
		},
		integrationId: {
			type: Number
		},
		sortBy: {
			type: String
		},
		sortDirection: {
			type: String
		}
	},
	data() {
		return {
			filters: {
				status: this.status,
				search: this.search,
				sortby: this.sortBy,
				sortdirection: this.sortDirection
			},
			page: 1,
			countPerPage: this.count,
			defaultFilters: {
				search: '',
				status: 'all',
				sortby: 'name',
				sortdirection: 'asc'
			},
			loading: true,
			loadingMore: false,
			displayNav: false,
			currentCustomerName: null,
			actions: null,
			statusTypeOptions: [
				{
					text: 'All Status',
					value: 'all'
				},
				{
					text: 'Active',
					value: 'active'
				},
				{
					text: 'Inactive',
					value: 'inactive'
				}
			],
			ddsOptions: [
				{ text: 'Bod Type', value: 'name' },
				{ text: 'Bod Version', value: 'version' }
			],
			siteBodIdData: 0
		};
	},
	computed: {
		...mapGetters(moduleName, [
			RELOAD_SITEBODS,
			SHOW_MODAL_SITEBOD,
			SITEBOD,
			SITEBODS,
			INTEGRATIONS
		]),
		urlNames() {
			let integrationsNameRoute = 'Integrations Third Parties';
			if (!_.isEmpty(this[INTEGRATIONS])) {
				const integration = this[INTEGRATIONS].items.find(
					integration => {
						return integration.id === this.integrationId;
					}
				);
				integrationsNameRoute = integration
					? integration.dealerNumberId
					: integrationsNameRoute;
			}

			return [
				{
					name: 'Third Party Manager',
					data: { path: '/integrations/thirdparties' }
				},
				{
					url: `/integrations/thirdparties/${this.thirdPartyId}/integrations`,
					name: integrationsNameRoute
				},
				{ name: 'SiteBods' }
			];
		},

		ddsValue: {
			get() {
				return {
					sortby: this.filters.sortby,
					sortdirection: this.filters.sortdirection
				};
			},
			set(value) {
				this.filters.sortby = value.sortby;
				this.filters.sortdirection = value.sortdirection;
			}
		},
		// pageTitle() {
		// 	const { dealershipGroupGuid } = this.sourceParams;

		// 	let customerName = this[GET_CUSTOMER_OPTION_NAME](
		// 		dealershipGroupGuid
		// 	);

		// 	return `SiteBods on ${customerName}`;
		// },
		hasResults() {
			return this[SITEBODS].items?.length;
		},
		resultCounter() {
			if (!this[SITEBODS].items) {
				return '0';
			}

			return `${this[SITEBODS].items?.length} of ${this[SITEBODS].totalCount}`;
		},
		hasMoreItemsToLoad() {
			return (
				this.siteBodsList.length <
				_.get(this[SITEBODS], 'totalCount', 0)
			);
		},
		siteBodsList() {
			return _.get(this[SITEBODS], 'items', []);
		}
	},

	methods: {
		...mapActions(moduleName, [SET_SITEBODS]),
		addSiteBod() {
			this.$store.dispatch(`${moduleName}/${SHOW_MODAL_SITEBOD}`, true);
		},
		async fetchData(page) {
			let query = { ...this.filters };
			query.search = decodeURIComponent(query.search);
			query.siteId = this.integrationId;

			query.page = page;
			query.count = this.countPerPage || 100;
			if (query.status) {
				query.active =
					query.status === 'all'
						? null
						: query.status === 'active'
						? true
						: false;
			}
			delete query.status;

			if (!this.loadingMore) {
				this.loading = true;
			}

			await this[SET_SITEBODS](query);
			this.loading = false;
			this.loadingMore = false;
		},
		updateRoute(queries) {
			let queryObj = getDifferentValues(this.defaultFilters, queries);
			if (this.countPerPage) {
				queryObj.count = this.countPerPage;
			}

			if (this[SHOW_MODAL_SITEBOD]) {
				if (queries.siteBodId) {
					queryObj.siteBodId = this.siteBodIdData;
				}
			} else {
				delete queryObj.siteBodId;
			}

			this.$router
				.push({
					path: `/integrations/thirdparties/${this.thirdPartyId}/integrations/${this.integrationId}/sitebods`,
					query: queryObj
				})
				.catch(() => {});
		},
		handleScrollEnd() {
			if (this.hasMoreItemsToLoad) {
				this.loadingMore = true;
				this.page += 1;
			}
		}
	},
	watch: {
		filters: {
			deep: true,
			immediate: true,
			handler(newValue) {
				this.updateRoute(newValue);
				if (this.page != 1) {
					this.page = 1;
				} else {
					this.fetchData(1);
				}
			}
		},
		page: {
			handler(page) {
				this.fetchData(page);
			}
		},
		[RELOAD_SITEBODS]: {
			handler(val) {
				if (val) {
					this.fetchData(1);
				}
			}
		},
		[SHOW_MODAL_SITEBOD]: {
			handler(val) {
				if (!_.isEmpty(this[SITEBOD])) {
					this.siteBodIdData = this[SITEBOD].id;
				} else {
					this.siteBodIdData = 0;
				}
				if (val && this.siteBodIdData > 0) {
					this.updateRoute({
						...this.filters,
						siteBodId: this.siteBodIdData
					});
				} else {
					this.updateRoute(this.filters);
				}
			}
		},
		'$route.query': {
			handler(newQuery) {
				if (!newQuery.siteBodId) {
					let newfilters = { ...this.defaultFilters, ...newQuery };

					if (!_.isEqual(newfilters, this.filters)) {
						this.filters = _.cloneDeep(newfilters);
					}
					this.$store.dispatch(`integrations/setSiteBod`, null);
					this.$store.dispatch(
						`integrations/showModalSiteBod`,
						false
					);
				}
			}
		}
	}
};
</script>
<style lang="scss" scoped>
@include mq($from: md) {
	.results-toolbar__search {
		width: 265px;
	}
}
</style>
